import {Injectable} from '@angular/core';
import {AutoInvestLoanViewModel} from './auto-invest-loan-view-model';
import {GaugedInvestment} from '../../../model/gauged-investment.model';

@Injectable()
export class AutoInvestLoanViewModelMapper {
    public convertToAutoInvestLoanViewModel(gaugedInvestment: GaugedInvestment): AutoInvestLoanViewModel {
        return <AutoInvestLoanViewModel>{
            roi: gaugedInvestment.loan.roi,
            filledPercentage: gaugedInvestment.loan.filled_percentage,
            loan: gaugedInvestment.loan,
            loanAmount: gaugedInvestment.loan.loan_amount,
            gaugedInvestmentAmount: gaugedInvestment.amount,
            rating: gaugedInvestment.loan.rating
        };
    }
}